module.exports = __webpack_public_path__ + "static/fonts/icomoon.7d6ffa5.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/otherIcon/fonts/icomoon.ttf?b7i6dh
// module id = 5aHt
// module chunks = 71